import { c as _c } from "react/compiler-runtime";
import { faExclamationTriangle, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import { Tooltip } from "react-tooltip";
import DateCountdown from "../date-countdown/DateCountdown";
import styles from "./MintCountdownBox.module.scss";
interface Props {
  mintInfo?: {
    title: string;
    date: number; // Unix seconds
    showAllowlistInfo?: boolean | undefined;
    isFinalized?: boolean | undefined;
    isEnded?: boolean | undefined;
    isSoldOut?: boolean | undefined;
  } | undefined;
  linkInfo?: {
    href: string;
    target: "_blank" | "_self";
  } | undefined;
  hideMintBtn?: boolean | undefined;
  small?: boolean | undefined;
  isError?: boolean | undefined;
}
export default function MintCountdownBox(props) {
  const $ = _c(37);
  const {
    mintInfo,
    linkInfo,
    hideMintBtn,
    small,
    isError
  } = props;
  const hasMintInfo = Boolean(mintInfo);
  const canShowMintButton = !small && !hideMintBtn && hasMintInfo && Boolean(linkInfo);
  const showSkeletonButton = !hasMintInfo;
  let t0;
  if ($[0] !== mintInfo) {
    t0 = mintInfo?.date === null || mintInfo?.date === undefined ? undefined : new Date(mintInfo.date * 1000);
    $[0] = mintInfo;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const countdownDate = t0;
  const showAllowlistInfo = mintInfo?.showAllowlistInfo;
  const t1 = small ? styles.countdownContainerShort : "";
  let t2;
  if ($[2] !== t1) {
    t2 = [styles.countdownContainer, t1];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const containerClasses = t2.join(" ");
  if (isError) {
    let t3;
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <h4 className="mb-3 tw-flex tw-items-center tw-gap-2"><FontAwesomeIcon icon={faExclamationTriangle} color="#FFD60A" className="tw-h-6 tw-w-6" />Error fetching mint information</h4>;
      t4 = <p className="mb-1 tw-font-medium">Please try again later.</p>;
      $[4] = t3;
      $[5] = t4;
    } else {
      t3 = $[4];
      t4 = $[5];
    }
    let t5;
    if ($[6] !== containerClasses) {
      t5 = <div className={containerClasses}>{t3}{t4}</div>;
      $[6] = containerClasses;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  if (mintInfo?.isSoldOut) {
    let t3;
    let t4;
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <h4 className="mb-3">✅ Mint Complete - Sold Out!</h4>;
      t4 = <p className="mb-1 tw-font-medium">All NFTs have been successfully minted.</p>;
      t5 = <p className="mb-0 tw-text-md">Thank you for participating!</p>;
      $[8] = t3;
      $[9] = t4;
      $[10] = t5;
    } else {
      t3 = $[8];
      t4 = $[9];
      t5 = $[10];
    }
    let t6;
    if ($[11] !== containerClasses) {
      t6 = <div className={containerClasses}>{t3}{t4}{t5}</div>;
      $[11] = containerClasses;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  if (mintInfo?.isFinalized) {
    let t3;
    let t4;
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <h4 className="mb-3">⌛️ Mint Phase Complete</h4>;
      t4 = <p className="mb-1 tw-font-medium">This mint phase has ended.</p>;
      t5 = <p className="mb-0 tw-text-md">Thank you for participating!</p>;
      $[13] = t3;
      $[14] = t4;
      $[15] = t5;
    } else {
      t3 = $[13];
      t4 = $[14];
      t5 = $[15];
    }
    let t6;
    if ($[16] !== containerClasses) {
      t6 = <div className={containerClasses}>{t3}{t4}{t5}</div>;
      $[16] = containerClasses;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    return t6;
  }
  let t3;
  if ($[18] !== showAllowlistInfo) {
    t3 = showAllowlistInfo && <><FontAwesomeIcon icon={faInfoCircle} data-tooltip-id="allowlist-info" data-tooltip-content="The timer displays the current time remaining for a specific phase of the drop. Please refer to the distribution plan to check if you are in the allowlist." className={styles.allowlistInfo} /><Tooltip id="allowlist-info" place="left" opacity={1} border="1px solid rgba(255, 255, 255, 0.15)" style={{
        backgroundColor: "#37373E",
        color: "white",
        padding: "10px 14px",
        maxWidth: "250px",
        fontSize: "14px",
        lineHeight: "1.4",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
        borderRadius: "6px"
      }} /></>;
    $[18] = showAllowlistInfo;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  const t4 = `pt-2 pb-2 tw-w-full ${!canShowMintButton && "text-center"}`;
  const t5 = mintInfo?.title;
  let t6;
  if ($[20] !== countdownDate || $[21] !== t5) {
    t6 = <DateCountdown title={t5} date={countdownDate} />;
    $[20] = countdownDate;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t4 || $[24] !== t6) {
    t7 = <div className={t4}>{t6}</div>;
    $[23] = t4;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== showSkeletonButton) {
    t8 = showSkeletonButton && <div className="pt-2 pb-2 tw-w-full"><button disabled={true} className={`pt-2 pb-2 btn-block no-wrap ${styles.mintBtn} ${styles.skeletonBtn}`}> </button></div>;
    $[26] = showSkeletonButton;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== canShowMintButton || $[29] !== linkInfo) {
    t9 = canShowMintButton && linkInfo && <div className="pt-2 pb-2 tw-w-full"><Link href={linkInfo.href} target={linkInfo.target} rel={linkInfo.target === "_blank" ? "noopener noreferrer" : undefined}><button className={`pt-2 pb-2 btn-block no-wrap ${styles.mintBtn}`}>Mint</button></Link></div>;
    $[28] = canShowMintButton;
    $[29] = linkInfo;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== containerClasses || $[32] !== t3 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t10 = <div className={containerClasses}>{t3}{t7}{t8}{t9}</div>;
    $[31] = containerClasses;
    $[32] = t3;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  return t10;
}